import { BtmPaymentMethodModel } from './btm-payment-method.model';

export class PaymentDetailsModel {
    btmPaymentMethod: BtmPaymentMethodModel;

    constructor() {
        this.btmPaymentMethod = undefined;
    }
}
